import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/workspace/axios';
import { getMyPDDErrorMessage, parseMyPDDResponse } from './queries';
import {
  resetMyPDDState,
  setMyPDDData,
  setMyPDDError,
  setMyPDDLoading,
} from './slice';

const ABC_GET_MY_PDD_ENDPOINT = '/abcapital/abhfl/pdd-data';

const getQueryParam = (key: string) => {
  try {
    const { hash, search } = window.location;
    const hashQueryString = hash.split('?')?.[1] || '';
    const hashParams = new URLSearchParams(hashQueryString);
    const searchParams = new URLSearchParams(search || '');
    return hashParams.get(key) || searchParams.get(key) || '';
  } catch (e) {
    return '';
  }
};

const getAuthToken = () => getQueryParam('auth_token');

const getUserCode = () => getQueryParam('user_code');

export const fetchMyPDDData = createAsyncThunk(
  'abcCustomPages/fetchMyPDDData',
  async ({ userCode }: { userCode: string }, { dispatch }) => {
    try {
      dispatch(setMyPDDLoading(true));
      dispatch(setMyPDDError(''));

      const response = await axios.post(
        ABC_GET_MY_PDD_ENDPOINT,
        {
          user_code: userCode,
        },
        {
          headers: {
            'x-vymo-auth-token': getAuthToken(),
          },
        },
      );

      dispatch(setMyPDDData(parseMyPDDResponse(response?.data)));
    } catch (error: any) {
      dispatch(
        setMyPDDError(getMyPDDErrorMessage(error, 'Unable to load PDD data.')),
      );
    } finally {
      dispatch(setMyPDDLoading(false));
    }
  },
);

const onActivate = ({ dispatch }) => {
  const userCode = getUserCode();

  if (userCode) {
    dispatch(fetchMyPDDData({ userCode }));
  } else {
    dispatch(setMyPDDError('User code is required to load PDD data.'));
  }
};

const onDeactivate = ({ dispatch }) => {
  dispatch(resetMyPDDState());
};

export default { onActivate, onDeactivate };
